import { useContext, useEffect } from "react";
import Footer from "./Footer";
import Header from "./Header";
import { useEmbeddedView } from "../hooks/useEmbeddedView";
import { ClientConfigurationContext } from "../context/ClientConfigurationContextProvider";

export default function Layout({ alerts, children }) {
    const embedded = useEmbeddedView();
    const clientConfiguration = useContext(ClientConfigurationContext);

    const hasEmbeddedAlertHeader = Boolean(
        clientConfiguration?.enableAlerts &&
        Array.isArray(alerts) &&
        alerts.length > 0
    );

    const removeGdkFixedHeaderOffset =
        embedded && clientConfiguration != null && !hasEmbeddedAlertHeader;

    useEffect(() => {
        const body = document.body;
        if (removeGdkFixedHeaderOffset) {
            body.classList.add("embedded-no-gdk-header-offset");
        } else {
            body.classList.remove("embedded-no-gdk-header-offset");
        }
        return () => body.classList.remove("embedded-no-gdk-header-offset");
    }, [removeGdkFixedHeaderOffset]);

    return (
        <main id="wrapper" className="bg-color--cloudy">
            <Header alerts={alerts} embedded={embedded} />
            <div className="content">
                {children}
            </div>
            {!embedded && <Footer />}
        </main>
    );
};
